const {registerBlockType} = wp.blocks;
const {RichText, MediaUpload, MediaUploadCheck, URLInputButton} = wp.blockEditor;
const {Button} = wp.components;
const {useEffect} = wp.element;

import teamPopup from '../../../resources/scripts/module/about';

registerBlockType('mailmetrics/our-team', {
  title: 'Our Team',
  icon: 'groups',
  category: 'layout',
  supports: {
    align: true,
    html: false,
  },
  attributes: {
    teamMembers: {
      type: 'array',
      default: [],
    },
    editingMemberIndex: {
      type: 'number',
      default: -1,
    },
    headerText: {
      type: 'string',
      default: 'Our Team',
    },
  },
  edit: ({attributes, setAttributes}) => {
    const {teamMembers, editingMemberIndex, headerText} = attributes;

    useEffect(() => {
      teamPopup();

      return () => {
      };
    }, [teamMembers.length]);

    const addTeamMember = () => {
      const newMember = {
        name: '',
        position: '',
        imageUrl: '',
        url: '',
        urlText: '',
        description: '',
        seeMoreText: 'See more'
      };
      setAttributes({teamMembers: [...teamMembers, newMember]});
    };

    const updateTeamMember = (newData, index) => {
      const newMembers = teamMembers.map((member, i) => i === index ? {...member, ...newData} : member);
      setAttributes({teamMembers: newMembers});
    };

    const removeTeamMember = (index) => {
      const newMembers = teamMembers.filter((_, i) => i !== index);
      setAttributes({teamMembers: newMembers});
    };

    const showPopup = (index) => {
      setAttributes({editingMemberIndex: index});
    };

    const closePopup = () => {
      setAttributes({editingMemberIndex: -1});
    };

    const handleInputFocus = (event) => {
      event.stopPropagation();
    };

    const handleInputKeyDown = (event) => {
      event.stopPropagation();
    };

    return (
      <>
        <div className="our-team">
          <div className="inner">
            <RichText
              tagName="h1"
              value={headerText}
              onChange={(newText) => setAttributes({headerText: newText})}
              placeholder="Our Team"
            />
            <div className="our-team-list">
              {teamMembers.map((member, index) => (
                <div key={index} className="box" data-info={JSON.stringify({
                  name: member.name,
                  position: member.position,
                  url: member.url,
                  urlText: member.urlText,
                  description: member.description
                })}>
                  <div className="box-top">
                    <MediaUploadCheck>
                      <MediaUpload
                        onSelect={(media) => updateTeamMember({imageUrl: media.url}, index)}
                        allowedTypes={['image']}
                        value={member.imageId}
                        render={({open}) => (
                          <Button onClick={open} isDefault>
                            {!member.imageUrl ? 'Select Image' : 'Replace Image'}
                          </Button>
                        )}
                      />
                    </MediaUploadCheck>
                    {member.imageUrl && <img src={member.imageUrl} alt={member.name}/>}
                  </div>
                  <div className="box-bottom">
                    <RichText
                      tagName="h6"
                      value={member.name}
                      onChange={(newText) => updateTeamMember({name: newText}, index)}
                      placeholder="Name"
                    />
                    <RichText
                      tagName="p"
                      value={member.position}
                      onChange={(newText) => updateTeamMember({position: newText}, index)}
                      placeholder="Position"
                    />
                    <RichText
                      tagName="a"
                      className="see-more"
                      value={member.seeMoreText}
                      onChange={(newText) => updateTeamMember({seeMoreText: newText}, index)}
                      onClick={() => showPopup(index)}
                      placeholder="See more"
                    />
                    <Button isSecondary onClick={() => showPopup(index)}>Edit Popup Content</Button>
                    <Button isDestructive onClick={() => removeTeamMember(index)}>Remove Team Member</Button>
                  </div>
                </div>
              ))}
              <Button isPrimary onClick={addTeamMember}>Add Team Member</Button>
            </div>
          </div>
        </div>

        <div className={`team-popup ${editingMemberIndex >= 0 ? ' popup-visible' : ''}`}>
          <div className="team-popup-content">
            <div className="team-popup-content-left">
              <RichText
                tagName={'p'}
                className={'name'}
                value={teamMembers[editingMemberIndex]?.name}
                onChange={(newText) => updateTeamMember({name: newText}, editingMemberIndex)}
                placeholder="Name"
              />
              <RichText
                tagName={'p'}
                className={'position'}
                value={teamMembers[editingMemberIndex]?.position}
                onChange={(newText) => updateTeamMember({position: newText}, editingMemberIndex)}
                placeholder="Position"
              />
            </div>
            <div className="team-popup-content-right">
              <RichText
                tagName={'p'}
                className={'description'}
                value={teamMembers[editingMemberIndex]?.description}
                onChange={(newText) => updateTeamMember({description: newText}, editingMemberIndex)}
                placeholder="Description"
              />
              <RichText
                title={teamMembers[editingMemberIndex]?.url}
                tagName={'a'}
                href={'#'}
                value={teamMembers[editingMemberIndex]?.urlText}
                onChange={(newText) => updateTeamMember({urlText: newText}, editingMemberIndex)}
                placeholder={"URL Text"}
              />
              <input type={"url"}
                     value={teamMembers[editingMemberIndex]?.url}
                     onChange={(e) => {
                       e.stopPropagation();
                       updateTeamMember({url: e.target.value}, editingMemberIndex);
                     }}
                     placeholder="URL"
              />
            </div>
            <Button className={'close'} onClick={closePopup}></Button>
          </div>
        </div>
      </>
    );
  },
  save: ({attributes}) => {
    const {teamMembers, headerText} = attributes;

    return (
      <>
        <section className="our-team">
          <div className="inner">
            <h1>{headerText}</h1>
            <div className="our-team-list">
              {teamMembers.map((member, index) => (
                <div key={index} className="box" data-info={JSON.stringify({
                  name: member.name,
                  position: member.position,
                  url: member.url,
                  urlText: member.urlText,
                  description: member.description
                })}>
                  <div className="box-top">
                    {member.imageUrl && <img src={member.imageUrl} alt={member.name}/>}
                  </div>
                  <div className="box-bottom">
                    <h6>{member.name}</h6>
                    <p>{member.position}</p>
                    <a className="see-more" href="#">{member.seeMoreText}</a>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
        <div className="team-popup">
          <div className="team-popup-content">
            <div className="team-popup-content-left">
              <p className="name"></p>
              <p className="position"></p>
            </div>
            <div className="team-popup-content-right">
              <p className="description"></p>
              <a href="" target="_blank" rel="noopener"></a>
            </div>
            <button className="close"></button>
          </div>
        </div>
      </>
    );
  }
});
